import React, { forwardRef } from "react";

import cn from "classnames";

import { extractProps } from "../../utils/react";

import type { LinkProps } from "./types";

import classes from "./Link.styl";

const LINK_DISPLAY_NAME = "Link";

/**
 * Базовый компонент для перехода по ссылке.
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?m=auto&node-id=2-114779" target="_blank">Спека</a>
 * @constructor
 *
 * @deprecated Используйте компонент TextLink.
 */
export const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
    const { customColorsStyles, currentProps } = extractProps(props, [
        "customColorsStyles",
    ]);

    const {
        view = "primary",
        size = "15",
        children,
        "data-tsid": tsid,
        customVarsStyles,
        ...restProps
    } = currentProps;

    const linkStyles = cn(
        classes["link"],
        classes[`__view-${view}`],
        size !== "custom" && classes[`__text-size-${size}`],
        customColorsStyles,
        customVarsStyles,
    );

    return (
        <a
            {...restProps}
            className={linkStyles}
            data-tsid={tsid}
            data-uikit={LINK_DISPLAY_NAME}
            ref={ref}
        >
            {children}
        </a>
    );
});

Link.displayName = LINK_DISPLAY_NAME;

export default Link;
